var scrollTo = function(destination, duration = 200, callback) {
		var easing = function(t) {
				return t * (2 - t);
			},
			documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight),
			windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight,
			destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop,
			destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset),
			start = window.pageYOffset,
			startTime ='now' in window.performance ? performance.now() : new Date().getTime(),
			scroll = function() {
				var now = 'now' in window.performance ? performance.now() : new Date().getTime(),
					time = Math.min(1, ((now - startTime) / duration)),
					timeFunction = easing(time);

				window.scrollTo(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

				if (Math.round(window.pageYOffset) === destinationOffsetToScroll) {
					if (callback) {
						callback();
					}
					window.cancelAnimationFrame(scroll);
				} else {
					window.requestAnimationFrame(scroll);
				}
			};

		scroll();
	};

module.exports = scrollTo;